import { FunctionComponent, useState, useEffect } from "react";
import {
  LoadingSpinner,
  PageContainer,
  PageTitle,
} from "src/components/generic";
import { TableCheckbox } from "src/components/inputs";
import Table from "src/components/tables/Table";
import { useAuth } from "src/context/AuthContext";
import { ToastStatus, useToast } from "src/context/ToastContext";
import { dynamo } from "src/utils";
import { userTypes } from "src/utils/types";
import { Consultant } from "src/utils/types/UserTypes";

const Consultants: FunctionComponent = () => {
  const columns: string[] = ["", "ID", "Name", "Email", "Phone"];

  const { user } = useAuth();
  const { setToast } = useToast();

  const [consultants, setConsultants] = useState<Consultant[]>([]);
  const [selectConsultants, setSelectConsultants] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const toggleSelectedClients = (checked: boolean, email: string) =>
    checked
      ? setSelectConsultants([...selectConsultants, email])
      : setSelectConsultants(
          selectConsultants.filter(
            (selectedEmail: string) => selectedEmail !== email
          )
        );

  const checkValidation = (email: string) => selectConsultants.includes(email);

  const rows = consultants.map((consultant: Consultant) => [
    <TableCheckbox
      checked={checkValidation(consultant.userInfo.email)}
      data={consultant.userInfo.email}
      toggleSelected={toggleSelectedClients}
    />,
    consultant.userId,
    consultant.userInfo.name,
    consultant.userInfo.email,
    consultant.userInfo.phone,
  ]);

  const fetchConsultants = async () => {
    setLoading(true);
    if (!user) return;

    try {
      const result = await dynamo.fetch.usersByType(
        userTypes.AccountTypes.NEATT
      );

      setConsultants(result?.users);
    } catch (error: any) {
      setToast({
        message: error?.message || "Failed to Fetch Partners",
        status: ToastStatus.FAIL,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) fetchConsultants();
  }, [user]);

  if (loading) return <LoadingSpinner />;
  return (
    <PageContainer>
      <PageTitle title="Consultants" />
      <Table columns={columns} rows={rows} />
    </PageContainer>
  );
};

export default Consultants;
